<div class="ui-g form-group" style="margin-bottom: 5px; width: 800px;"
    *ngIf="response.success!=null && response.success==true">

    <!-- <div class = "card" *ngIf="doctor.user_guid == doctor.doctor_id"> -->
    <div class="card">
        <p-table #dt styleClass="ui-table-cars" id="doctors-grid" expandableRows="true" [responsive]="true">
            <ng-template pTemplate="caption" style="color: aliceblue;">
                <tr>
                    <td style="text-align: justify;">
                        <img [src]="this.getImageUrl(this.defualt_doctor_image,profile.data.avatar_url)" height="120px"
                            alt="Dr. Photo">
                        <h4>{{profile.data.doctor_profile.salutation | titlecase}}
                            {{profile.data.first_name}}
                            {{profile.data.middle_name==null?'':profile.data.middle_name}}
                            {{profile.data.last_name}},
                            {{profile.data.doctor_profile.degree}}
                        </h4>

                        <h4>
                            {{profile.data.doctor_profile.speciality.specialty_name}},
                            {{profile.data.state_name}},
                            {{profile.data.country.country_name}}
                        </h4>
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="header" let-columns>
                <tr style="text-align: justify;" *ngIf="profile.data.role_type!=null">
                    <h4><b>Role</b></h4>
                    {{profile.data.role_type.title}}
                </tr>
                <tr style="text-align: justify;" *ngIf="profile.data.date_of_birth!=null">
                    <h4><b>Date of Birth</b></h4>
                    {{(profile.data.date_of_birth | date:'mediumDate')}}
                </tr>
                <tr style="text-align: justify;"
                    *ngIf="profile.data.address_line_1!=null && profile.data.city!=null && profile.data.state_name!=null">
                    <h4><b>Address</b></h4>
                    {{profile.data.address_line_1+', '+
                    profile.data.city+', '+
                    profile.data.state_name+','+
                    profile.data.country.country_name}}
                </tr>
                <tr style="text-align: justify;" *ngIf="profile.data.doctor_profile.primary_contact_number!=null">
                    <h4><b>Primary Contact Number</b></h4>
                    {{profile.data.doctor_profile.primary_contact_number}}
                </tr>
                <tr style="text-align: justify;" *ngIf="profile.data.doctor_profile.secondary_speciality?.length>0">
                    <h4><b>Subspecialties</b></h4>
                    <ul *ngFor="let specialty of profile.data.doctor_profile.secondary_speciality">
                        <li>{{specialty}}</li>
                    </ul>
                </tr>
                <tr style="text-align: justify;" *ngIf="profile.data.doctor_profile.years_experience!=null">
                    <h4><b>Years of Experience</b></h4>
                    {{profile.data.doctor_profile.years_experience+' Years'}}
                </tr>
                <tr style="text-align: justify;" *ngIf="profile.data.doctor_profile.npi_number!=null">
                    <h4><b>NPI Number</b></h4>
                    {{profile.data.doctor_profile.npi_number}}
                </tr>
                <tr style="text-align: justify;" *ngIf="profile.data.doctor_profile.revalidation_cme!=null">
                    <h4><b>Re Validation CME</b></h4>
                    {{profile.data.doctor_profile.revalidation_cme}}
                </tr>
                <tr style="text-align: justify;" class="format-lines"
                    *ngIf="profile.data.doctor_profile.description?.length>0">
                    <h4><b>Bio</b></h4>
                    {{profile.data.doctor_profile.description}}
                </tr>
                <tr style="text-align: left;" *ngIf="profile.languages.length>0">
                    <h4><b>Languages Spoken</b></h4>
                    <ul>
                        <li class="format-lines" *ngFor="let l of profile.languages">
                            {{l.language_name+" ("+l.english_name+")"}}
                        </li>
                    </ul>
                </tr>
                <tr style="text-align: justify;"
                    *ngIf="profile.data.doctor_profile.education?.medical_school?.length>0">
                    <h4><b>Medical School</b></h4>
                    <ul>
                        <li class="format-lines"
                            *ngFor="let edu of profile.data.doctor_profile.education?.medical_school">
                            {{edu.name}} :
                            {{edu.year}}
                        </li>
                    </ul>
                </tr>

                <tr style="text-align: justify;" *ngIf="profile.data.doctor_profile.education?.fellowship?.length>0">
                    <h4><b>Fellowship</b></h4>
                    <ul>
                        <li class="format-lines" *ngFor="let edu of profile.data.doctor_profile.education?.fellowship">
                            {{edu.name}} :
                            {{edu.year}}
                        </li>
                    </ul>
                </tr>

                <tr style="text-align: left;" *ngIf="profile.data.doctor_profile.board_certification?.length>0">
                    <h4><b>Board Certifications</b></h4>
                    <ul>
                        <li class="format-lines" *ngFor="let board of profile.data.doctor_profile.board_certification">
                            {{board}}
                        </li>
                    </ul>
                </tr>
                <tr style="text-align: left;" *ngIf="profile.data.doctor_profile.honors_awards_recognition?.length>0">
                    <h4><b>Honors, Awards & Recognitions</b></h4>
                    <ul>
                        <li class="format-lines"
                            *ngFor="let honors of profile.data.doctor_profile.honors_awards_recognition">
                            {{honors}}
                        </li>
                    </ul>
                </tr>
                <tr style="text-align: left;" *ngIf="profile.data.doctor_profile.publications?.length>0">
                    <h4><b>Publications</b></h4>
                    <ul>
                        <li class="format-lines" *ngFor="let publication of profile.data.doctor_profile.publications">
                            {{publication}}
                        </li>
                    </ul>
                </tr>
                <tr style="text-align: justify;" *ngIf="profile.data.doctor_profile.hospital_privileges?.length>0">
                    <h4><b>Hospital Privileges</b></h4>
                    <ul>
                        <li class="format-lines"
                            *ngFor="let privileges of profile.data.doctor_profile.hospital_privileges">
                            {{privileges}}
                        </li>
                    </ul>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
<div class="row container justify-content-center text-center alert alert-danger"
    *ngIf="response.success!=null && response.success==false">
    <p *ngIf="response.error!=null">{{response.error.message}}</p>
    <div *ngIf="serverError?.error!=null && serverError?.statusCode!=500">
        <p *ngFor="let message of serverError?.message">{{message}}</p>
    </div>
    <div *ngIf="serverError?.error!=null && serverError?.statusCode==500">
        <p>{{serverError?.message}}</p>
    </div>

</div>
<h4 *ngIf="posting">Fetching Doctor Profile...</h4>
<p-progressSpinner [style]="{width: '50px', height: '50px'}" *ngIf="posting" strokeWidth="6"></p-progressSpinner>
